export const COMPONENT_NAME = "registration-message";
